import Axios from 'axios'
import {visitorTypeUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_visitor_types (context) {
    Axios.get(visitorTypeUrls.getAllVisitorTypes).then(function (response) {
      context.commit('GET_ALL_VISITOR_TYPES', response.data)
    })
  },
  get_visitor_types (context, publicId) {
    Axios.get(visitorTypeUrls.getVisitorTypes + publicId).then(function (response) {
      context.commit('GET_VISITOR_TYPES', response.data)
    })
  },
  get_deleted_visitor_types (context) {
    Axios.get(visitorTypeUrls.getDeletedVisitorType).then(function (response) {
      context.commit('GET_DELETED_VISITOR_TYPES', response.data)
    })
  },
  get_visitor_type (context, publicId) {
    Axios.get(visitorTypeUrls.getVisitorType + publicId).then(function (response) {
      context.commit('GET_VISITOR_TYPE', response.data)
    })
  },
  post_visitor_type (context, data) {
    Axios.post(visitorTypeUrls.postVisitorType, data).then(function () {
      context.dispatch('get_all_visitor_types')
    }).catch(function (error) {
    })
  },
  update_visitor_type (context, data) {
    Axios.patch(visitorTypeUrls.editVisitorType, data).then(function () {
      context.dispatch('get_all_visitor_types')
    }).catch(function (error) {
    })
  },
  delete_visitor_type (context, data) {
    Axios.patch(visitorTypeUrls.deleteVisitorType, data).then(function (response) {
      context.dispatch('get_all_visitor_types')
    })
  },
  restoreVisitorType (context, publicId) {
    Axios.get(visitorTypeUrls.restoreVisitorType + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_VISITOR_TYPES', response.data)
      router.push({
        name: 'Module.VisitorTypes'
      })
    })
  }
}
